import React, { useState, useEffect, useCallback } from "react";
import { AnimatePresence } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BootSequence from "../components/BootSequence";
import HeroOS from "../components/sections/HeroOS";
import Meaning from "../components/sections/Meaning";
import EngineeringServices from "../components/sections/EngineeringServices";
import EngineeringWorkflow from "../components/sections/EngineeringWorkflow";
import EpcPartnerSection from "../components/sections/EpcPartnerSection";
import FeaturedProducts from "../components/sections/FeaturedProducts";
import WhyDebsun from "../components/sections/WhyDebsun";
import Roadmap from "../components/sections/Roadmap";
import Research from "../components/sections/Research";
import Contact from "../components/sections/Contact";
import AISolutionFinder from "../components/AISolutionFinder";
import { scrollToId, scrollToHashFromLocation } from "../lib/scroll";

export default function LandingPage() {
  const [aiOpen, setAiOpen] = useState(false);
  const [booting, setBooting] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem("debsun-booted") !== "1";
  });

  useEffect(() => {
    if (booting) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [booting]);

  useEffect(() => {
    if (booting) return;
    scrollToHashFromLocation();
  }, [booting]);

  const finishBoot = useCallback(() => {
    sessionStorage.setItem("debsun-booted", "1");
    setBooting(false);
  }, []);

  return (
    <>
      <AnimatePresence>
        {booting && <BootSequence onDone={finishBoot} />}
      </AnimatePresence>

      <Header onOpenAI={() => setAiOpen(true)} />
      <main data-testid="landing-main" className="overflow-x-hidden">
        <HeroOS
          onExplore={() => scrollToId("#divisions")}
          onVision={() => scrollToId("#products")}
          onTalk={() => scrollToId("#contact")}
        />
        <Meaning />
        <EngineeringServices />
        <EngineeringWorkflow />
        <EpcPartnerSection />
        <FeaturedProducts />
        <WhyDebsun />
        <Roadmap />
        <Research />
        <Contact />
      </main>
      <Footer />

      <AISolutionFinder open={aiOpen} onClose={() => setAiOpen(false)} />
    </>
  );
}
